import { Footer } from "@/components/Layout/BaseLayouts/Footer/Footer.tsx";
import { FCC } from "@/types";

import { ContentContainer } from "./ContentContainer";
import { Header, HeroTheme } from "./Header";
import { SkipToContent } from "./SkipToContent";

interface Props {
  headline?: string;
  /** See Header: the hero headline is this page's h1. */
  headlineIsPageTitle?: boolean;
  /** Illustration set of the hero banner. Defaults to the SIM cards. */
  heroTheme?: HeroTheme;
}

/**
 * Every direct child passed to DefaultPageLayout must declare its own col-span
 * - there's no full-width fallback.
 */
export const DefaultPageLayout: FCC<Props> = ({
  children,
  headline,
  headlineIsPageTitle,
  heroTheme,
}) => {
  return (
    <div className="flex min-h-screen flex-col bg-background-secondary">
      <SkipToContent />
      <Header
        variant="welcome"
        headline={headline}
        headlineIsPageTitle={headlineIsPageTitle}
        heroTheme={heroTheme}
      />
      <ContentContainer className="flex-grow">{children}</ContentContainer>
      <Footer />
    </div>
  );
};
